import { useParams } from "react-router-dom";

export const useFunnelSourceEditPageParams = () => {
  const { siteSlug = "", funnelSlug = "", sourceTagSlug = "" } = useParams();

  return { siteSlug, funnelSlug, sourceTagSlug };
};
